import React, { Component } from 'react';
import { BrowserRouter, Switch, Route } from 'react-router-dom';
import { connect } from 'react-redux';
import { refresTokenAction, setWebViewAction } from './MainAction';
import Simulador from '../pages/Simulador';
import Documentos from '../pages/Documentos';
import Evaluacion from '../pages/Evaluacion';
// import Step4 from '../pages/Step4';
import { Page404 } from '../pages/Page404';
import Steps from '../common/Step/Steps';
import NavTef from '../common/navTef/NavTef'
import SeguridadMain from './SeguridadMain';
import i18n from '../../config/I18n';


class Main extends Component {
  constructor(props) {
    super(props);
    this.props = props;
    this.state = { currentCount: 0 }
  }

  componentDidMount() {

    // determinamos WV
    const { setWebView } = this.props;
    const w = window.navigator;
    const standalone = w.standalone ? w.standalone : false;
    const userAgent = w.userAgent.toLowerCase();
    const safari = /safari/.test(userAgent);
    const ios = /iphone|ipod|ipad/.test(userAgent);
    if (ios) {
      if (!standalone && !safari) {
        setWebView();
      };
    } else {
      const agente = w.userAgent;
      const serchAgente = agente.indexOf('wv');
      if (serchAgente !== -1) {
        setWebView();
      }
    };
    // setWebView();
    // fin wv

    const setTime = Number(process.env.TIME_TOKEN_SECONS);
    this.setState({ currentCount: setTime })
    this.intervalId = setInterval(this.timer.bind(this), 1000);
    this.refres(false)
  }


  volverPortalPrivado = () => {
    window.top.location.href = process.env.URL_PORTAL_PRIVADO;
  };

  refres = async (ciclo) => {
    const { refresToken } = this.props;
    await refresToken(true);
    const { tokenLive, wv } = this.props;
    if (!tokenLive) {
      if (!wv) {
        this.volverPortalPrivado();
      }
    } else if (tokenLive && ciclo) {
      const setTime = Number(process.env.TIME_TOKEN_SECONS);
      this.setState({ currentCount: setTime })
      this.intervalId = setInterval(this.timer.bind(this), 1000);
    }
  }

  timer() {
    const { currentCount } = this.state;
    const { tokenLive } = this.props;
    if (tokenLive && currentCount >= 1) {
      this.setState({ currentCount: currentCount - 1 })
    } else if (tokenLive && currentCount < 1) {
      clearInterval(this.intervalId);
      this.refres(true);
    }
    // console.log(currentCount)
  }

  render() {
    const { stepActual, obtenerIdFlujo, usuario, fecha } = this.props;
    const trace = JSON.parse(sessionStorage.getItem('trace'));
    trace.trace.push({ paso: "main" })
    sessionStorage.setItem('trace', JSON.stringify(trace));
    return (
      <BrowserRouter>
        <NavTef user={usuario} date={fecha} />
        {obtenerIdFlujo !== null && obtenerIdFlujo === 1 && (
          <Steps
            steps={[
              { "step": i18n.t('steps.step1') },
              { "step": i18n.t('steps.step2') },
              { "step": i18n.t('steps.step3') },
              { "step": i18n.t('steps.step4') },
              { "step": i18n.t('steps.step5') },
            ]}
            stepActual={stepActual}
            titulo={i18n.t('steps.mainTitle')}
            subTitulo={i18n.t('steps.mainSubTitle')}
            idFlujo={obtenerIdFlujo}
            parrafo={i18n.t('steps.mainSubTitle')}
          />
        )}

        <Switch>
          <Route path="/" exact component={SeguridadMain} />
          <Route path="/Simulador" component={Simulador} />
          <Route path="/Documentos" component={Documentos} />
          <Route path="/Evaluacion" component={Evaluacion} />
          <Route path="/Page404" component={Page404} />
        </Switch>
      </BrowserRouter>
    );
  }
}

function mapStateToProps(state) {
  return {
    showLoader: state.loader.showLoader,
    showErrorGenerico: state.modalError.showErrorGenerico,
    stepActual: state.step.stepActual,
    obtenerIdFlujo: state.obtenerCampanaUsuario.idFlujo,
    usuario: state.datosPersona.datosBasicosPersona !== null ? state.datosPersona.datosBasicosPersona.nombreUsuario : null,
    fecha: state.datosPersona.datosBasicosPersona !== null ? state.datosPersona.datosBasicosPersona.fechaSesion : null,
    tokenLive: state.sessionUsuario.tokenLive,
    wv: state.webViuw.estado

  }
}

const mapDispatchToProps = dispatch => {
  return {
    refresToken: (tokenLiveType) => dispatch(refresTokenAction(tokenLiveType)),
    setWebView: () => dispatch(setWebViewAction())

  }
}


export default connect(mapStateToProps, mapDispatchToProps)(Main);
